import React from 'react'
import { Paragraph } from '@fs/zion-ui'
import { type SearchResult } from '../types'

type TrainingDataItemProps = Readonly<{
  result: SearchResult
  searchQuery: string
}>

const TrainingDataItem = ({ result, searchQuery }: TrainingDataItemProps) => {
  return (
    <div style={{ minWidth: 300 }}>
      <Paragraph size="xs">{`${searchQuery}|${result?.id}|0.8498|WEB_SERVICE`}</Paragraph>
    </div>
  )
}

export default TrainingDataItem
